// Éditeur de personnalisation REVDECO (Fabric.js) — page /pages/personnaliser.
// Contexte produit reçu de la fiche via sessionStorage['revdeco-editor-ctx'] :
//   { handle, url, title, code, isTextile, qty, color, colors:[{name,img}], print:{positions:[...]} }
// À la validation : localStorage['revdeco-cfg-<handle>'] = { ts, qty, positions:[{id,label,png}], logo }
// — la fiche pré-coche les emplacements et joint les BAT + logo à la commande.
// bouton retour navigateur : retour bfcache = état périmé (sélection modifiée sur la
// fiche entre-temps) → on recharge, le brouillon en sessionStorage préserve le visuel
window.addEventListener('pageshow', function (e) { if (e.persisted) window.location.reload(); });
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('rdcfg');
  if (!root || typeof fabric === 'undefined') return;
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var fmt = function (n) { return n.toFixed(2).replace('.', ',') + ' €'; };
  var PR = window.REVDECO_PRICING;

  var ctx = null;
  try { ctx = JSON.parse(sessionStorage.getItem('revdeco-editor-ctx') || 'null'); } catch (e) { }
  if (!ctx || !ctx.handle) { $('rdcfgEmpty').hidden = false; return; }
  $('rdcfgMain').hidden = false;

  var POSITIONS = (ctx.print && ctx.print.positions) || [];
  // textile en BRODERIE : seuls les emplacements que midOcean brode (technique E) —
  // avant, un REGENT « brodé » proposait le torse 28 × 42 cm, non brodable (vu 2026-09-29)
  if (ctx.isTextile && ctx.mode === 'broderie') {
    var _bro = POSITIONS.filter(function (p) { return (p.techniques || []).some(function (t) { return t.id === 'E'; }); });
    if (_bro.length) POSITIONS = _bro;
  }
  // FUSION des variantes techniques d'une même zone (« FRONT » + « FRONT TD1 » →
  // un emplacement, techniques réunies, dims maxi) — retour Denis 2026-09-14 : les
  // doublons EN/FR rendaient la liste incompréhensible. Même règle que la fiche.
  if (window.RD_POS_BASE && POSITIONS.length) {
    var _byBase = {}, _order = [];
    POSITIONS.forEach(function (p) {
      var b = window.RD_POS_BASE(p.id);
      if (!_byBase[b]) {
        _byBase[b] = {}; for (var k in p) _byBase[b][k] = p[k];
        _byBase[b].id = b; _byBase[b].techniques = []; _order.push(b);
      }
      var m = _byBase[b];
      if ((parseFloat(p.w) || 0) * (parseFloat(p.h) || 0) > (parseFloat(m.w) || 0) * (parseFloat(m.h) || 0)) {
        m.w = p.w; m.h = p.h; m.unit = p.unit;
        if (p.image) m.image = p.image;
        if (p.pts) m.pts = p.pts;
      }
      (p.techniques || []).forEach(function (t) {
        if (!m.techniques.some(function (x) { return x.id === t.id; })) m.techniques.push(t);
      });
    });
    POSITIONS = _order.map(function (b) { return _byBase[b]; });
  }
  // broderie : côté maxi 20 cm (décision Denis 2026-09-29, coût midOcean au-delà) — la zone
  // bleue (pts, pixels de l'image de position) est réduite autour de son centre
  if (ctx.isTextile && ctx.mode === 'broderie' && window.REVDECO_PRICING && REVDECO_PRICING.BRODERIE_MAX_MM) {
    POSITIONS = POSITIONS.map(function (p) {
      var k = String(p.unit || 'mm').toLowerCase().indexOf('cm') === 0 ? 10 : 1;
      var w = (parseFloat(p.w) || 0) * k, h = (parseFloat(p.h) || 0) * k, M = REVDECO_PRICING.BRODERIE_MAX_MM;
      if (!(w > M || h > M)) return p;
      var q = {}; for (var key in p) q[key] = p[key];
      var fw = w > M ? M / w : 1, fh = h > M ? M / h : 1;
      q.w = Math.round(w * fw); q.h = Math.round(h * fh); q.unit = 'mm';
      if (p.pts && p.pts.length === 4) {
        var cx = (p.pts[0] + p.pts[2]) / 2, cy = (p.pts[1] + p.pts[3]) / 2;
        var hw = (p.pts[2] - p.pts[0]) / 2 * fw, hh = (p.pts[3] - p.pts[1]) / 2 * fh;
        q.pts = [cx - hw, cy - hh, cx + hw, cy + hh];
      }
      return q;
    });
  }
  var isTextile = !!ctx.isTextile;
  // technique choisie sur la fiche (modèle TH4) : impression (défaut) ou broderie
  var MODE = ctx.mode === 'broderie' ? 'broderie' : 'impression';
  var TEX_BROD = { id: 'E', name: 'Broderie', colours: 8 }; // pseudo-technique textile
  // textile : libellés métier ; objets : table générée revdeco-pos-fr.js (1 057 positions FR)
  var POS_FR = { 'FRONT': 'Torse (devant)', 'BACK': 'Dos', 'CHEST': 'Poitrine (petit logo)', 'ARM RIGHT': 'Manche droite', 'ARM LEFT': 'Manche gauche', 'ARM': 'Manche', 'NECK': 'Nuque', 'SIDE 1': 'Côté 1', 'SIDE 2': 'Côté 2' };
  var posLabel = function (id) {
    var u = String(id).toUpperCase();
    if (ctx.isTextile && POS_FR[u]) return POS_FR[u];
    if (window.RD_POS_LABEL) return window.RD_POS_LABEL(id);
    return POS_FR[u] || id;
  };

  // ---- En-tête produit ----
  var back = ctx.url || ('/products/' + ctx.handle);
  $('rdcfgCrumbProd').textContent = ctx.title || 'Produit';
  $('rdcfgCrumbProd').href = back;
  $('rdcfgProdBack').href = back;
  $('rdcfgProdName').textContent = ctx.title || '';
  $('rdcfgProdMeta').textContent = (ctx.code ? 'Réf. ' + ctx.code : '') + (ctx.color ? ' · Coloris : ' + ctx.color : '')
    + (isTextile && MODE === 'broderie' ? ' · Broderie' : '');
  document.title = 'Personnaliser — ' + (ctx.title || '') + ' — REVDECO';

  // sélection réelle du client (coloris × quantités saisis sur la fiche) — si présente,
  // l'éditeur la reprend obligatoirement : coloris limités aux siens, quantité verrouillée.
  var SEL = (ctx.sel && ctx.sel.length) ? ctx.sel : null;
  var selColorObj = null;
  if (ctx.colors && ctx.colors.length) {
    selColorObj = ctx.colors.filter(function (c) { return c.name === ctx.color; })[0] || ctx.colors[0];
  }
  if (SEL && !selColorObj) selColorObj = SEL[0];
  function prodThumb() {
    var img = $('rdcfgProdImg');
    var u = (selColorObj && selColorObj.img) || null;
    if (u) { img.src = u; img.hidden = false; } else { img.hidden = true; }
  }
  prodThumb();

  // ---- Canvas ----
  var wrap = $('rdcfgCw');
  var size = Math.max(280, Math.min(wrap.clientWidth - 20, 560));
  var canvas = new fabric.Canvas('rdcfgCanvas', { width: size, height: size, backgroundColor: '', preserveObjectStacking: true, selection: true });
  var ACCENT = '#0071e3', INK = '#1d1d1f';
  function cc() { return wrap.querySelector('.canvas-container') || wrap; }

  var selPos = 0;
  // ---- Polices de marquage (refonte 2026-08-14, demande Denis « très pro, sans gadget ») ----
  // Chargées par Google Fonts dans la section Liquid ; préchargées ici pour que le
  // canvas (et donc le BAT) dispose des vraies métriques, gras et italiques compris.
  var RD_FONT_STYLES = {
    'Inter': { b: 1, i: 1 }, 'Montserrat': { b: 1, i: 1 }, 'Playfair Display': { b: 1, i: 1 }, 'Lora': { b: 1, i: 1 },
    'Oswald': { b: 1, i: 0 }, 'Caveat': { b: 1, i: 0 }, 'Baloo 2': { b: 1, i: 0 },
    'Bebas Neue': { b: 0, i: 0 }, 'Pacifico': { b: 0, i: 0 }, 'Archivo Black': { b: 0, i: 0 }
  };
  var RD_FONTS_READY = new Promise(function (resolve) {
    var kick = function () {
      if (!document.fonts || !document.fonts.load) return resolve();
      var specs = [];
      Object.keys(RD_FONT_STYLES).forEach(function (f) {
        var s = RD_FONT_STYLES[f];
        specs.push('400 16px "' + f + '"');
        if (s.b) specs.push('700 16px "' + f + '"');
        if (s.i) { specs.push('italic 400 16px "' + f + '"', 'italic 700 16px "' + f + '"'); }
      });
      Promise.all(specs.map(function (sp) { return document.fonts.load(sp, 'AbcÉé0123').catch(function () { }); })).then(resolve, resolve);
    };
    // ⚠️ document.fonts.load ne connaît les familles qu'une fois la feuille de style
    // Google Fonts CHARGÉE — pas seulement présente dans le DOM (vécu 2026-08-14) :
    // on attend la fin du chargement de la page avant de précharger
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', kick, { once: true });
  });
  RD_FONTS_READY.then(function () { if (typeof canvas !== 'undefined' && canvas) canvas.requestRenderAll(); });

  var artByPos = {};   // JSON fabric des éléments, par id de position
  var thumbByPos = {}; // aperçu miniature (PNG) du visuel composé, par id de position
  var techByPos = {};  // objets midOcean : index technique choisi, par id de position

  var zoneRect = null;
  // Zone de marquage : dimensionnée en mm réels (300 mm ≈ 34 % du canevas) et placée selon la vue.
  function zoneFor(pos) {
    if (!pos) return { cx: 0.5, cy: 0.50, w: 0.30, h: 0.34 };
    var id = (pos.id || '').toUpperCase();
    var W = parseFloat(pos.w) || 150, H = parseFloat(pos.h) || 150;
    var refMM = 300, ref = 0.34;
    var w = Math.min(0.40, Math.max(0.05, (W / refMM) * ref));
    var h = Math.min(0.52, Math.max(0.05, (H / refMM) * ref));
    var cx = 0.5, cy = 0.50;
    if (/CHEST|POCKET|POITRINE/.test(id)) { cx = 0.40; cy = 0.40; }
    else if (/ARM|SLEEVE|MANCHE/.test(id)) { cx = 0.5; cy = 0.36; }
    else if (/BACK|DOS|NAPE|NECK/.test(id)) { cx = 0.5; cy = 0.48; }
    return { cx: cx, cy: cy, w: w, h: h };
  }
  function addZoneRect(l, t, w, h) {
    if (zoneRect) { canvas.remove(zoneRect); zoneRect = null; }
    zoneRect = new fabric.Rect({
      left: l + w / 2, top: t + h / 2, originX: 'center', originY: 'center',
      width: w, height: h, fill: '', stroke: ACCENT, strokeDashArray: [6, 5], strokeWidth: 1.5,
      selectable: false, evented: false, excludeFromExport: true
    });
    canvas.add(zoneRect); canvas.sendToBack(zoneRect);
  }
  function addZone() {
    var z = zoneFor(POSITIONS[selPos]);
    addZoneRect(size * (z.cx - z.w / 2), size * (z.cy - z.h / 2), size * z.w, size * z.h);
  }

  // ---- Zone active + confinement : le visuel ne peut pas sortir du cadre ----
  function zoneBounds() {
    if (zoneRect) {
      return { l: zoneRect.left - zoneRect.width / 2, t: zoneRect.top - zoneRect.height / 2, r: zoneRect.left + zoneRect.width / 2, b: zoneRect.top + zoneRect.height / 2 };
    }
    var z = zoneFor(POSITIONS[selPos]);
    return { l: size * (z.cx - z.w / 2), t: size * (z.cy - z.h / 2), r: size * (z.cx + z.w / 2), b: size * (z.cy + z.h / 2) };
  }
  // Tant que la zone EXACTE (pts midOcean, chargée avec l'image de position) n'est pas
  // posée, on ne confine pas : sinon la restauration d'un visuel serait « clampée » avec
  // la zone de repli approximative et l'image bougerait/rétrécirait à chaque réouverture.
  var zoneExactPending = false;
  function clampToZone(o) {
    if (!o || !o.rdArt) return;
    if (zoneExactPending) return;
    var zb = zoneBounds();
    var zw = zb.r - zb.l, zh = zb.b - zb.t;
    o.setCoords();
    var r = o.getBoundingRect(true);
    if (r.width > zw || r.height > zh) {
      var f = Math.min(zw / r.width, zh / r.height);
      o.scale((o.scaleX || 1) * f);
      o.setCoords(); r = o.getBoundingRect(true);
    }
    var dx = 0, dy = 0;
    if (r.left < zb.l) dx = zb.l - r.left;
    if (r.left + r.width > zb.r) dx = zb.r - (r.left + r.width);
    if (r.top < zb.t) dy = zb.t - r.top;
    if (r.top + r.height > zb.b) dy = zb.b - (r.top + r.height);
    if (dx || dy) { o.set({ left: o.left + dx, top: o.top + dy }); o.setCoords(); }
  }
  function clampAll() {
    canvas.getObjects().forEach(function (o) { if (o.rdArt) clampToZone(o); });
    canvas.requestRenderAll();
  }
  canvas.on('object:moving', function (e) { clampToZone(e.target); });
  canvas.on('object:scaling', function (e) { clampToZone(e.target); });
  canvas.on('object:rotating', function (e) { clampToZone(e.target); });
  canvas.on('text:changed', function (e) { clampToZone(e.target); });

  // Fond : image de position midOcean (montre la zone exacte) sinon photo du coloris.
  // Les images Shopify CDN autorisent le CORS → posées DANS le canevas (le BAT exporté
  // montre alors le produit) ; les images midOcean sont mises en fond CSS (export = visuel seul).
  function bgUrlFor() {
    var p = POSITIONS[selPos];
    if (p && p.image) return p.image;
    if (selColorObj && selColorObj.img) return selColorObj.img;
    return null;
  }
  function isShopifyCdn(u) { return /cdn\.shopify\.com/.test(u || ''); }
  var bgToken = 0; // invalide les chargements d'images obsolètes (changements rapides de position)
  function refreshBg() {
    var p = POSITIONS[selPos];
    var url = bgUrlFor();
    var tok = ++bgToken;
    canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas));
    wrap.style.backgroundImage = '';
    cc().style.backgroundImage = '';
    if (p && p.image && p.pts) { zoneExactPending = true; posBg(p, tok); return; }
    if (!url) { addZone(); return; }
    if (isShopifyCdn(url)) {
      fabric.Image.fromURL(url, function (img) {
        if (tok !== bgToken) return;
        if (!img || !img.width) { cssBg(url, tok); return; }
        var s = (size * 0.82) / Math.max(img.width, img.height);
        img.set({ originX: 'center', originY: 'center', left: size / 2, top: size * 0.5, scaleX: s, scaleY: s });
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
      }, { crossOrigin: 'anonymous' });
    } else { cssBg(url, tok); }
    var posImg = p && p.image;
    if (posImg) { if (zoneRect) { canvas.remove(zoneRect); zoneRect = null; } }
    else addZone();
  }
  // Image de position midOcean calée au pixel : le cadre réel est aux coordonnées `pts`
  // (référentiel = pixels de l'image). On affiche l'image SANS cadre (-no-area) et on
  // dessine NOTRE zone bleue exactement dessus — elle sert aussi de contrainte.
  function posBg(p, tok) {
    // priorité : image de position DANS le coloris du client (code SKU), sans cadre ;
    // repli : coloris par défaut midOcean, puis image avec cadre, puis fond CSS.
    var code = selColorObj && selColorObj.cc;
    var base = p.image;
    var alt = code ? base.replace(/-[A-Z0-9]+_POS/i, '-' + code + '_POS') : null;
    var noArea = function (u) { return u.replace(/\.jpe?g($|\?)/i, '-no-area.jpg$1'); };
    var cands = [];
    if (alt && alt !== base) cands.push(noArea(alt), alt);
    cands.push(noArea(base), base);
    (function next(i) {
      if (tok !== bgToken) return;
      if (i >= cands.length) {
        cssBg(base, tok);
        if (zoneRect) { canvas.remove(zoneRect); zoneRect = null; }
        zoneExactPending = false;
        return;
      }
      tryImg(cands[i], function (im, u) { placePosBg(p, im, u, tok); }, function () { next(i + 1); });
    })(0);
  }
  function placePosBg(p, im, u, tok) {
    if (tok !== bgToken) return;
    var iw = im.naturalWidth || 1000, ih = im.naturalHeight || 1000;
    var s = Math.min(size / iw, size / ih);
    var w = iw * s, h = ih * s, ox = (size - w) / 2, oy = (size - h) / 2;
    // image DANS le canevas (le CDN midOcean autorise le CORS) : les BAT exportés et les
    // miniatures montrent le produit avec le visuel posé dessus. Repli : fond CSS.
    fabric.Image.fromURL(u, function (img) {
      if (tok !== bgToken) return;
      if (!img || !img.width) {
        var el = cc();
        el.style.backgroundImage = 'url("' + u + '")';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundPosition = ox.toFixed(1) + 'px ' + oy.toFixed(1) + 'px';
        el.style.backgroundSize = w.toFixed(1) + 'px ' + h.toFixed(1) + 'px';
      } else {
        img.set({ originX: 'left', originY: 'top', left: ox, top: oy, scaleX: s, scaleY: s });
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
      }
      addZoneRect(ox + p.pts[0] * s, oy + p.pts[1] * s, (p.pts[2] - p.pts[0]) * s, (p.pts[3] - p.pts[1]) * s);
      zoneExactPending = false;
      clampAll();
    }, { crossOrigin: 'anonymous' });
  }
  function tryImg(u, ok, err) {
    var im = new Image();
    im.onload = function () { ok(im, u); };
    im.onerror = err;
    im.referrerPolicy = 'no-referrer';
    im.src = u;
  }
  function cssBg(url, tok) {
    var pre = new Image();
    pre.onload = function () {
      if (tok !== bgToken) return;
      wrap.style.backgroundImage = 'url("' + url + '")';
      wrap.style.backgroundRepeat = 'no-repeat';
      wrap.style.backgroundPosition = 'center 47%';
      wrap.style.backgroundSize = 'auto 76%';
    };
    pre.referrerPolicy = 'no-referrer';
    pre.src = url;
  }

  // ---- Sélection : synchronisation avec la fiche (une seule source de vérité) ----
  function totalSelQty() { return (SEL || []).reduce(function (a, c) { return a + (c.qty || 0); }, 0); }
  function persistSelQty() {
    // reporte les quantités éditées ici dans le stockage lu par la fiche produit
    var KEY = 'revdeco-qty-' + ctx.handle;
    var cur = {};
    try { cur = JSON.parse(sessionStorage.getItem(KEY) || 'null') || {}; } catch (e) { }
    var grid = cur.grid || {};
    (SEL || []).forEach(function (c) {
      (c.sizes || []).forEach(function (x) {
        if (x.vid == null) return;
        if (x.q > 0) grid[String(x.vid)] = x.q; else delete grid[String(x.vid)];
      });
    });
    cur.grid = grid; if (cur.simple == null) cur.simple = 50;
    try { sessionStorage.setItem(KEY, JSON.stringify(cur)); } catch (e) { }
    ctx.sel = SEL || [];
    ctx.qty = totalSelQty();
    try { sessionStorage.setItem('revdeco-editor-ctx', JSON.stringify(ctx)); } catch (e) { }
  }
  function applySelEdit(name, sizeS, q) {
    if (!SEL) return;
    var c = SEL.filter(function (x) { return x.name === name; })[0];
    if (!c || !c.sizes) return;
    c.sizes.forEach(function (x) { if (x.s === sizeS) x.q = Math.max(0, q || 0); });
    afterSelChange();
  }
  function removeSelColor(name) {
    if (!SEL) return;
    var c = SEL.filter(function (x) { return x.name === name; })[0];
    if (c && c.sizes) c.sizes.forEach(function (x) { x.q = 0; });
    else if (c) c.qty = 0;
    afterSelChange();
  }
  function afterSelChange() {
    persistSelQty(); // écrit aussi les zéros → les cases correspondantes se vident sur la fiche
    SEL.forEach(function (c) {
      if (c.sizes) {
        c.sizes = c.sizes.filter(function (x) { return x.q > 0; });
        c.qty = c.sizes.reduce(function (a, x) { return a + x.q; }, 0);
      }
    });
    SEL = SEL.filter(function (c) { return (c.qty || 0) > 0; });
    if (!SEL.length) SEL = null;
    persistSelQty();
    var aux = $('rdcfgQtyAux');
    if (SEL) {
      qty = totalSelQty();
      $('rdcfgQty').value = qty;
      if (aux) aux.textContent = SEL.map(function (c) { return c.qty + ' ' + c.name; }).join(' + ') + ' — fixée par votre commande';
      if (selColorObj && !SEL.some(function (c) { return c.name === selColorObj.name; })) {
        var n = SEL[0].name;
        selColorObj = (ctx.colors || []).filter(function (c) { return c.name === n; })[0] || SEL[0];
        prodThumb(); refreshBg();
      }
    } else {
      $('rdcfgQminus').style.display = '';
      $('rdcfgQplus').style.display = '';
      $('rdcfgQty').readOnly = false;
      if (aux) aux.textContent = 'plus de sélection — estimation libre, quantités à régler sur la fiche';
    }
    renderColors(); render(); renderWarnings();
  }

  // ---- Coloris : la sélection du client (éditable) sinon tout le nuancier ----
  function renderColors() {
    var list = SEL || (ctx.colors || []).slice(0, 24);
    if (!list.length || (!SEL && list.length < 2)) { $('rdcfgColorCard').hidden = true; return; }
    $('rdcfgColorCard').hidden = false;
    $('rdcfgColors').innerHTML = list.map(function (c) {
      var on = selColorObj && c.name === selColorObj.name;
      var img = c.img || ((ctx.colors || []).filter(function (x) { return x.name === c.name; })[0] || {}).img;
      var pic = img ? '<img src="' + esc(img) + '" alt="' + esc(c.name) + '" loading="lazy">' : esc(c.name.slice(0, 2));
      if (SEL) {
        var sizes = (c.sizes && c.sizes.length)
          ? '<div class="rdcfg__selc__sizes">' + c.sizes.map(function (x) {
            return '<label>' + esc(x.s) + '<input inputmode="numeric" value="' + x.q + '" data-sn="' + esc(c.name) + '" data-ss="' + esc(x.s) + '"></label>';
          }).join('') + '</div>'
          : '';
        return '<div class="rdcfg__selc rdcfg__selc--edit' + (on ? ' rdcfg__selc--on' : '') + '">'
          + '<button type="button" class="rdcfg__selc__pick" data-n="' + esc(c.name) + '" title="Voir l\'aperçu sur ce coloris">'
          + pic + '<span class="rdcfg__selc__t">' + esc(c.name) + '<small>' + c.qty + ' pièce' + (c.qty > 1 ? 's' : '') + '</small></span></button>'
          + '<button type="button" class="rdcfg__selc__x" data-x="' + esc(c.name) + '" title="Retirer ce coloris">✕</button>'
          + sizes
          + '</div>';
      }
      return '<button type="button" class="rdcfg__sw' + (on ? ' rdcfg__sw--on' : '') + '" title="' + esc(c.name) + '" data-n="' + esc(c.name) + '">' + pic + '</button>';
    }).join('')
      + (SEL ? '<button type="button" class="rdcfg__selc__add" id="rdcfgAddColor">+ Ajouter un coloris ou des tailles</button>' : '')
      + (SEL && SEL.length > 1 ? '<div class="rdcfg__selc__note">✓ Le même visuel s\'applique à tous vos coloris — rien à refaire par couleur.</div>' : '');
    $('rdcfgColorName').textContent = SEL
      ? 'vos coloris — l\'aperçu bascule, le visuel est identique'
      : (selColorObj ? selColorObj.name : '');
    $('rdcfgColors').querySelectorAll('[data-n]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = this.getAttribute('data-n');
        selColorObj = (ctx.colors || []).filter(function (c) { return c.name === n; })[0]
          || (SEL || []).filter(function (c) { return c.name === n; })[0]
          || selColorObj;
        renderColors(); prodThumb(); refreshBg();
      });
    });
    $('rdcfgColors').querySelectorAll('.rdcfg__selc__x').forEach(function (x) {
      x.addEventListener('click', function () { removeSelColor(this.getAttribute('data-x')); });
    });
    $('rdcfgColors').querySelectorAll('.rdcfg__selc__sizes input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        applySelEdit(this.getAttribute('data-sn'), this.getAttribute('data-ss'), parseInt(this.value, 10));
      });
    });
    var add = $('rdcfgAddColor');
    if (add) add.addEventListener('click', function () { saveDraft(); window.location.href = back + '#rdGridWrap'; });
  }

  // ---- Sauvegarde / restauration du visuel par position ----
  // restauration en cours (attente des polices) : le canevas est encore vide — un
  // render() → saveArt() à ce moment effaçait le visuel de l'emplacement actif (vu 2026-09-29)
  var restoreGen = 0, pendingGen = 0; // pendingGen : génération dont la restauration est en attente
  function saveArt() {
    if (pendingGen && pendingGen === restoreGen) return;
    var pos = POSITIONS[selPos]; if (!pos) return;
    var objs = canvas.getObjects().filter(function (o) { return o.rdArt; });
    if (objs.length) {
      artByPos[pos.id] = objs.map(function (o) { return o.toJSON(['selectable', 'rdArt']); });
      try { thumbByPos[pos.id] = canvas.toDataURL({ format: 'png', multiplier: 120 / size }); } catch (e) { }
    } else { delete artByPos[pos.id]; delete thumbByPos[pos.id]; }
  }
  function restoreArt(cb) {
    var gen = ++restoreGen;
    // verrou posé AVANT la purge : retirer un texte en cours d'édition déclenche
    // text:editing:exited → onArtChange → saveArt, qui effaçait l'emplacement de destination
    pendingGen = gen;
    canvas.getObjects().slice().forEach(function (o) { if (o.rdArt) canvas.remove(o); });
    canvas.discardActiveObject();
    var pos = POSITIONS[selPos];
    var arts = pos && artByPos[pos.id];
    if (!arts || !arts.length) { pendingGen = 0; canvas.requestRenderAll(); if (cb) cb(); return; }
    // polices chargées AVANT de reconstituer les textes : sinon Fabric fige de
    // mauvaises métriques (police de repli) et le BAT sort avec la mauvaise typo
    RD_FONTS_READY.then(function () {
    fabric.util.enlivenObjects(arts, function (objs) {
      // une autre restauration a été lancée entre-temps (clics rapides) : la plus récente fait foi
      if (gen !== restoreGen) return;
      objs.forEach(function (o) {
        o.rdArt = true;
        if (o.type === 'image' && o._element) o.rdOpaqueBg = detectOpaqueBg(o._element);
        canvas.add(o); clampToZone(o);
      });
      pendingGen = 0;
      canvas.requestRenderAll(); if (cb) cb();
    });
    });
  }

  // ---- Positions ----
  function renderPositions() {
    if (!POSITIONS.length) { $('rdcfgPosCard').hidden = true; return; }
    $('rdcfgPosCard').hidden = false;
    $('rdcfgPos').innerHTML = POSITIONS.map(function (p, i) {
      var has = !!artByPos[p.id];
      var th = thumbByPos[p.id];
      // textile : prix de l'emplacement affiché sur la carte (le client compose
      // en voyant ce que chaque face coûte — décision Denis 2026-08-05)
      var priceLine = '';
      if (isTextile && PR) {
        var uu = PR.atelierUnit(p, qty, MODE);
        priceLine = '<span class="rdcfg__posc__p">+ ' + fmt(uu) + '/pièce</span>';
      }
      return '<button type="button" class="rdcfg__posc' + (i === selPos ? ' rdcfg__posc--on' : '') + '" data-i="' + i + '">'
        + '<span class="rdcfg__posc__th">' + (th ? '<img src="' + th + '" alt="Aperçu ' + esc(posLabel(p.id)) + '">' : '+') + '</span>'
        + '<span class="rdcfg__posc__n">' + esc(posLabel(p.id)) + '</span>'
        + '<span class="rdcfg__posc__s' + (has ? ' rdcfg__posc__s--ok' : '') + '">' + (has ? '✓ visuel ajouté' : 'vide') + '</span>'
        + priceLine
        + '</button>';
    }).join('');
    $('rdcfgPos').querySelectorAll('.rdcfg__posc').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +this.getAttribute('data-i');
        if (i === selPos) return;
        saveArt();
        selPos = i;
        renderPositions(); refreshBg(); renderTechs();
        restoreArt(function () { render(); renderWarnings(); });
        syncTools();
        var p = POSITIONS[selPos];
        $('rdcfgZone').textContent = 'Zone de marquage max : ' + p.w + ' × ' + p.h + ' ' + (p.unit || 'mm');
      });
    });
    var p0 = POSITIONS[selPos];
    if (p0) $('rdcfgZone').textContent = 'Zone de marquage max : ' + p0.w + ' × ' + p0.h + ' ' + (p0.unit || 'mm');
  }

  // ---- Techniques (objets midOcean seulement — textile : l'atelier choisit) ----
  function techsOf(pos) { return (pos && pos.techniques) || []; }
  function renderTechs() {
    if (isTextile) {
      // textile : pas de choix de technique ici — mais si la fiche a envoyé
      // « broderie », on affiche la carte avec la pédagogie fils (sans boutons)
      var card = $('rdcfgTechCard'), note = $('rdcfgTechNote');
      if (MODE === 'broderie' && card && note) {
        card.hidden = false;
        $('rdcfgTechs').innerHTML = '<div class="rdcfg__tech rdcfg__tech--on" style="cursor:default"><div class="cn">Broderie</div><div class="cd">' + TEX_BROD.colours + ' couleurs de fil max · aplats uniquement</div></div>';
        note.hidden = false;
        note.textContent = 'La broderie est réalisée en fils : jusqu\'à ' + TEX_BROD.colours + ' couleurs de fil par visuel (large choix de teintes, assorties à votre logo), en aplats uniquement — les photos et dégradés ne sont pas brodables.';
      } else if (card) { card.hidden = true; }
      return;
    }
    var pos = POSITIONS[selPos];
    var list = techsOf(pos);
    if (!list.length) { $('rdcfgTechCard').hidden = true; return; }
    $('rdcfgTechCard').hidden = false;
    var sel = techByPos[pos.id] || 0;
    var colourLabel = function (c, name) {
      if (c == null || c === '0') return 'sans couleur (relief / gravure)';
      if (/brod/i.test(name || '')) return c + ' couleur' + (String(c) === '1' ? '' : 's') + ' de fil max · aplats uniquement';
      return c + ' couleur' + (String(c) === '1' ? '' : 's') + ' max';
    };
    $('rdcfgTechs').innerHTML = list.map(function (t, i) {
      return '<button type="button" class="rdcfg__tech' + (i === sel ? ' rdcfg__tech--on' : '') + '" data-i="' + i + '"><div class="cn">' + esc(t.name) + '</div><div class="cd">' + esc(colourLabel(t.colours, t.name)) + '</div></button>';
    }).join('');
    // pédagogie broderie : le client comprend que la limite est un nombre de FILS
    var selTech = list[sel];
    var techNote = $('rdcfgTechNote');
    if (techNote) {
      if (selTech && /brod/i.test(selTech.name || '')) {
        techNote.hidden = false;
        techNote.textContent = 'La broderie est réalisée en fils : jusqu\'à ' + (selTech.colours || 8) + ' couleurs de fil par visuel (large choix de teintes, assorties à votre logo), en aplats uniquement — les photos et dégradés ne sont pas brodables.';
      } else {
        techNote.hidden = true;
        techNote.textContent = '';
      }
    }
    $('rdcfgTechs').querySelectorAll('.rdcfg__tech').forEach(function (b) {
      b.addEventListener('click', function () {
        techByPos[pos.id] = +this.getAttribute('data-i');
        saveDraft();
        renderTechs(); render(); renderWarnings();
      });
    });
  }

  // ---- Quantité ----
  var qty = Math.max(1, parseInt(ctx.qty, 10) || 50);
  if (SEL) {
    // quantité imposée par la commande en cours sur la fiche — non modifiable ici
    qty = SEL.reduce(function (a, c) { return a + (c.qty || 0); }, 0) || qty;
    $('rdcfgQminus').style.display = 'none';
    $('rdcfgQplus').style.display = 'none';
    $('rdcfgQty').readOnly = true;
    var aux = $('rdcfgQtyAux');
    if (aux) aux.textContent = SEL.map(function (c) { return c.qty + ' ' + c.name; }).join(' + ') + ' — fixée par votre commande';
    var editBtn = $('rdcfgEditSel');
    if (editBtn) {
      editBtn.hidden = false;
      editBtn.addEventListener('click', function () {
        saveDraft(); // le visuel en cours est conservé pour le retour
        window.location.href = back + '#rdGridWrap';
      });
    }
  }
  function setQty(v) { if (SEL) { $('rdcfgQty').value = qty; return; } qty = Math.max(1, v || 1); $('rdcfgQty').value = qty; render(); }
  $('rdcfgQty').value = qty;
  $('rdcfgQminus').addEventListener('click', function () { setQty(qty - (qty > 25 ? 25 : 1)); });
  $('rdcfgQplus').addEventListener('click', function () { setQty(qty + (qty >= 25 ? 25 : 1)); });
  $('rdcfgQty').addEventListener('change', function () { setQty(parseInt(this.value, 10)); });

  // ---- Outils élément ----
  function active() { return canvas.getActiveObject(); }
  function isText(o) { return o && (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox'); }
  var isBold = function (o) { return String(o.fontWeight) === '700' || o.fontWeight === 'bold'; };
  function syncTools() {
    var o = active();
    var tools = $('rdcfgTools'), noSel = $('rdcfgNoSel');
    if (o) {
      tools.classList.add('on'); noSel.style.display = 'none';
      var txt = isText(o);
      $('rdcfgFontRow').style.display = txt ? '' : 'none';
      $('rdcfgStyleRow').style.display = txt ? '' : 'none';
      $('rdcfgSpaceRow').style.display = txt ? '' : 'none';
      if (o.fill && /^#([0-9a-f]{6})$/i.test(o.fill)) $('rdcfgObjColor').value = o.fill;
      if (txt) {
        if (o.fontFamily) $('rdcfgObjFont').value = o.fontFamily;
        var st = RD_FONT_STYLES[o.fontFamily] || { b: 1, i: 1 };
        var bB = $('rdcfgBold'), bI = $('rdcfgItalic');
        bB.disabled = !st.b; bI.disabled = !st.i;
        bB.classList.toggle('on', !!st.b && isBold(o));
        bI.classList.toggle('on', !!st.i && o.fontStyle === 'italic');
        bB.title = st.b ? 'Gras' : 'Cette police n\'existe qu\'en un seul style';
        bI.title = st.i ? 'Italique' : 'Cette police n\'a pas d\'italique';
      }
    } else { tools.classList.remove('on'); noSel.style.display = ''; }
  }
  $('rdcfgObjColor').addEventListener('input', function () { var o = active(); if (!o) return; o.set('fill', this.value); canvas.requestRenderAll(); renderWarnings(); });
  // le texte est re-mesuré après chaque changement de style (les métriques changent)
  var retext = function (o) { if (o.initDimensions) o.initDimensions(); o.setCoords(); clampToZone(o); canvas.requestRenderAll(); syncTools(); onArtChange(); };
  $('rdcfgObjFont').addEventListener('change', function () {
    var o = active(); if (!isText(o)) return;
    var v = this.value, st = RD_FONT_STYLES[v] || { b: 1, i: 1 };
    var apply = function () {
      o.set('fontFamily', v);
      if (!st.b && isBold(o)) o.set('fontWeight', '400');
      if (!st.i && o.fontStyle === 'italic') o.set('fontStyle', 'normal');
      retext(o);
    };
    if (document.fonts && document.fonts.load) {
      Promise.all([document.fonts.load('400 16px "' + v + '"', 'Abc'), st.b ? document.fonts.load('700 16px "' + v + '"', 'Abc') : null])
        .then(apply).catch(apply);
    } else apply();
  });
  $('rdcfgBold').addEventListener('click', function () {
    var o = active(); if (!isText(o)) return;
    o.set('fontWeight', isBold(o) ? '400' : '700'); retext(o);
  });
  $('rdcfgItalic').addEventListener('click', function () {
    var o = active(); if (!isText(o)) return;
    o.set('fontStyle', o.fontStyle === 'italic' ? 'normal' : 'italic'); retext(o);
  });
  // espacement des lettres (charSpacing Fabric : millièmes d'em)
  var spaceStep = function (d) {
    var o = active(); if (!isText(o)) return;
    var v = (o.charSpacing || 0) + d;
    o.set('charSpacing', Math.max(-100, Math.min(600, v))); retext(o);
  };
  $('rdcfgSpaceLess').addEventListener('click', function () { spaceStep(-40); });
  $('rdcfgSpaceMore').addEventListener('click', function () { spaceStep(40); });
  function scaleActive(f) { var o = active(); if (!o) return; o.scale((o.scaleX || 1) * f); o.setCoords(); clampToZone(o); canvas.requestRenderAll(); renderWarnings(); }
  $('rdcfgBigger').addEventListener('click', function () { scaleActive(1.12); });
  $('rdcfgSmaller').addEventListener('click', function () { scaleActive(1 / 1.12); });
  function rot(d) { var o = active(); if (!o) return; o.rotate(((o.angle || 0) + d) % 360); o.setCoords(); clampToZone(o); canvas.requestRenderAll(); }
  $('rdcfgRotL').addEventListener('click', function () { rot(-15); });
  $('rdcfgRotR').addEventListener('click', function () { rot(15); });
  $('rdcfgFwd').addEventListener('click', function () { var o = active(); if (o) { canvas.bringForward(o); canvas.requestRenderAll(); } });
  $('rdcfgBack').addEventListener('click', function () { var o = active(); if (o) { canvas.sendBackwards(o); if (zoneRect) canvas.sendToBack(zoneRect); canvas.requestRenderAll(); } });
  $('rdcfgDel').addEventListener('click', function () { var o = active(); if (o) { canvas.remove(o); canvas.discardActiveObject(); canvas.requestRenderAll(); syncTools(); onArtChange(); } });
  canvas.on('selection:created', syncTools);
  canvas.on('selection:updated', syncTools);
  canvas.on('selection:cleared', syncTools);
  document.addEventListener('keydown', function (e) {
    var o = active();
    if ((e.key === 'Delete' || e.key === 'Backspace') && o && !o.isEditing) {
      e.preventDefault(); canvas.remove(o); canvas.discardActiveObject(); canvas.requestRenderAll(); syncTools(); onArtChange();
    }
  });

  // ---- Avertissements « preflight » (contraste, définition, fond, taille de texte) ----
  function colorTone(name) {
    var n = (name || '').toLowerCase();
    if (/blanc|ivoire|beige|crème|creme|jaune|citron|sable|naturel|ciel|pastel|pâle|pale|chiné clair|or$/.test(n)) return 'clair';
    if (/noir|profond|marine|navy|anthracite|foncé|fonce|chocolat|bordeaux|violet|encre|carbone|denim|kaki/.test(n)) return 'sombre';
    return 'moyen';
  }
  function artLuminance(o) {
    if (isText(o)) {
      var h = /^#?([0-9a-f]{6})$/i.exec(String(o.fill || ''));
      if (!h) return null;
      var v = parseInt(h[1], 16);
      return (0.299 * (v >> 16 & 255) + 0.587 * (v >> 8 & 255) + 0.114 * (v & 255)) / 255;
    }
    if (o._element) {
      try {
        var c = document.createElement('canvas'); c.width = 24; c.height = 24;
        var g = c.getContext('2d');
        g.clearRect(0, 0, 24, 24);
        g.drawImage(o._element, 0, 0, 24, 24);
        var d = g.getImageData(0, 0, 24, 24).data;
        var sum = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] > 60) { sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; n++; }
        }
        return n ? sum / n / 255 : null;
      } catch (e) { return null; }
    }
    return null;
  }
  function detectOpaqueBg(el) {
    // bords opaques ET clairs sur tout le pourtour = fond blanc probable (photo/JPEG/Google)
    try {
      var c = document.createElement('canvas'); c.width = 32; c.height = 32;
      var g = c.getContext('2d');
      g.clearRect(0, 0, 32, 32);
      g.drawImage(el, 0, 0, 32, 32);
      var pts = [[1, 1], [30, 1], [1, 30], [30, 30], [15, 1], [1, 15], [30, 15], [15, 30]];
      var opaqueLight = 0;
      for (var i = 0; i < pts.length; i++) {
        var d = g.getImageData(pts[i][0], pts[i][1], 1, 1).data;
        if (d[3] > 240 && d[0] > 228 && d[1] > 228 && d[2] > 228) opaqueLight++;
      }
      return opaqueLight >= 7;
    } catch (e) { return false; }
  }
  function collectWarnings() {
    var list = [];
    var p = POSITIONS[selPos];
    var mmW = p ? parseFloat(p.w) || 0 : 0;
    var zb = zoneBounds();
    var pxPerMm = mmW ? (zb.r - zb.l) / mmW : 0;
    var colors = SEL || (selColorObj && selColorObj.name ? [selColorObj] : []);
    canvas.getObjects().forEach(function (o) {
      if (!o.rdArt) return;
      var lum = artLuminance(o);
      if (lum != null) {
        colors.forEach(function (c) {
          var tone = colorTone(c.name);
          if (tone === 'sombre' && lum < 0.28) list.push('Visuel sombre sur « ' + c.name + ' » : il sera peu visible — préférez une version claire ou ajoutez un contour.');
          if (tone === 'clair' && lum > 0.8) list.push('Visuel très clair sur « ' + c.name + ' » : il sera peu visible — préférez une version foncée.');
        });
      }
      if (o.type === 'image' && o._element && pxPerMm) {
        var wMm = o.getScaledWidth() / pxPerMm;
        var dpi = wMm > 0 ? o._element.naturalWidth / (wMm / 25.4) : 999;
        if (dpi < 90) list.push('Image en très basse définition (~' + Math.round(dpi) + ' dpi à cette taille) : rendu pixellisé garanti — utilisez un fichier plus grand.');
        else if (dpi < 145) list.push('Définition un peu juste (~' + Math.round(dpi) + ' dpi) : 150 dpi minimum recommandé à cette taille d\'impression.');
        if (o.rdOpaqueBg) list.push('Le fond de votre image n\'est pas transparent : le rectangle blanc sera imprimé tel quel. Fournissez un PNG à fond transparent (pas une image « fond blanc » récupérée sur le web).');
      }
      if (isText(o) && pxPerMm) {
        var hMm = o.getScaledHeight() / pxPerMm;
        if (hMm > 0 && hMm < 8) list.push('Texte très petit (~' + Math.round(hMm) + ' mm de haut) : difficilement lisible imprimé — 8 mm minimum conseillé.');
      }
    });
    // limite de couleurs de la technique : la broderie compte en FILS par visuel,
    // la sérigraphie/tampographie en encres — on compare au visuel réellement posé.
    // Textile en mode broderie (pilule fiche) : mêmes contrôles que la broderie objet.
    if (p && (!isTextile || MODE === 'broderie')) {
      var tech = isTextile ? TEX_BROD : techsOf(p)[techByPos[p.id] || 0];
      var maxc = tech ? parseInt(tech.colours, 10) : 0;
      if (tech && maxc > 0) {
        var total = 0, photo = false, mesurable = true;
        canvas.getObjects().forEach(function (o) {
          if (!o.rdArt) return;
          var n = artColourCount(o);
          if (n == null) { mesurable = false; return; }
          total += n;
          if (o.type === 'image' && n > 12) photo = true;
        });
        var isB = /brod/i.test(tech.name || '');
        if (mesurable && total > maxc) {
          list.push((isB
            ? 'Broderie : jusqu\'à ' + maxc + ' couleurs de fil par visuel'
            : tech.name + ' : ' + maxc + ' couleur' + (maxc > 1 ? 's' : '') + ' maximum')
            + ' — le vôtre en compte environ ' + total + '. Simplifiez-le (aplats) ou choisissez une autre technique.');
        }
        if (isB && photo) {
          list.push('Ce visuel ressemble à une photo : la broderie ne reproduit ni photos ni dégradés (conversion en aplats de fils). Fournissez un logo aux contours nets.');
        }
      }
    }
    return list.filter(function (m, i) { return list.indexOf(m) === i; });
  }

  // Estimation du nombre de couleurs d'un élément : un texte = 1 couleur ; une image est
  // échantillonnée en 48×48 puis quantifiée (64 cases) — seules les cases couvrant ≥ 2 %
  // des pixels opaques comptent (l'anticrénelage des bords est ignoré).
  function artColourCount(o) {
    if (isText(o)) return 1;
    if (o.type === 'image' && o._element) {
      if (o.rdColourCount !== undefined) return o.rdColourCount;
      try {
        var cv = document.createElement('canvas');
        cv.width = 48; cv.height = 48;
        var g = cv.getContext('2d');
        g.drawImage(o._element, 0, 0, 48, 48);
        var d = g.getImageData(0, 0, 48, 48).data;
        var bins = {}, opaque = 0;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 128) continue;
          opaque++;
          var k = (d[i] >> 6) + '-' + (d[i + 1] >> 6) + '-' + (d[i + 2] >> 6);
          bins[k] = (bins[k] || 0) + 1;
        }
        var n = 0;
        for (var k2 in bins) { if (bins[k2] >= opaque * 0.02) n++; }
        o.rdColourCount = opaque ? Math.max(n, 1) : null;
      } catch (e) { o.rdColourCount = null; }
      return o.rdColourCount;
    }
    return null;
  }
  function renderWarnings() {
    var box = $('rdcfgWarn');
    if (!box) return;
    var list = collectWarnings();
    box.hidden = !list.length;
    box.innerHTML = list.map(function (m) { return '<div class="rdcfg__warn__it">⚠️ ' + esc(m) + '</div>'; }).join('');
  }

  // ---- Logo / texte ----
  var logoFile = null; // {name, data} — fichier d'origine, joint à la commande pour l'atelier
  function addImageToCanvas(dataUrl) {
    fabric.Image.fromURL(dataUrl, function (img) {
      var zb = zoneBounds();
      var sc = Math.min((zb.r - zb.l) * 0.8 / img.width, (zb.b - zb.t) * 0.8 / img.height, 1);
      img.set({ left: (zb.l + zb.r) / 2, top: (zb.t + zb.b) / 2, originX: 'center', originY: 'center', scaleX: sc, scaleY: sc });
      img.rdArt = true;
      if (img._element) img.rdOpaqueBg = detectOpaqueBg(img._element);
      canvas.add(img); clampToZone(img); canvas.setActiveObject(img); canvas.requestRenderAll(); onArtChange();
    });
  }

  // ---- « Vos images » : bibliothèque PARTAGÉE entre tous les produits (modèle TH4) ----
  var LIB_KEY = 'revdeco-library';
  function libGet() { try { return JSON.parse(localStorage.getItem(LIB_KEY) || '[]') || []; } catch (e) { return []; } }
  function libAdd(name, data) {
    if (!data || data.length > 1600000) return; // trop lourde pour le stockage navigateur
    var lib = libGet().filter(function (x) { return x.name !== name; });
    lib.unshift({ name: name, data: data, ts: Date.now() });
    while (lib.length > 8) lib.pop();
    for (;;) {
      try { localStorage.setItem(LIB_KEY, JSON.stringify(lib)); break; }
      catch (e) { if (lib.length <= 1) break; lib.pop(); } // stockage plein : retire les plus anciennes
    }
    renderLibrary();
  }
  function renderLibrary() {
    var box = $('rdcfgLib'), wrap = $('rdcfgLibWrap');
    if (!box || !wrap) return;
    var lib = libGet();
    wrap.hidden = !lib.length;
    box.innerHTML = lib.map(function (x, i) {
      return '<span class="rdcfg__lib__it">'
        + '<button type="button" class="rdcfg__lib__im" data-i="' + i + '" title="' + esc(x.name) + ' — cliquer pour l\'ajouter"><img src="' + x.data + '" alt="' + esc(x.name) + '"></button>'
        + '<button type="button" class="rdcfg__lib__x" data-x="' + i + '" title="Retirer de vos images">✕</button>'
        + '</span>';
    }).join('');
    box.querySelectorAll('.rdcfg__lib__im').forEach(function (b) {
      b.addEventListener('click', function () {
        var x = libGet()[+this.getAttribute('data-i')];
        if (!x) return;
        logoFile = { name: x.name, data: x.data };
        addImageToCanvas(x.data);
      });
    });
    box.querySelectorAll('.rdcfg__lib__x').forEach(function (b) {
      b.addEventListener('click', function () {
        var lib2 = libGet(); lib2.splice(+this.getAttribute('data-x'), 1);
        try { localStorage.setItem(LIB_KEY, JSON.stringify(lib2)); } catch (e) { }
        renderLibrary();
      });
    });
  }

  $('rdcfgBtnLogo').addEventListener('click', function () { $('rdcfgFile').click(); });
  $('rdcfgFile').addEventListener('change', function () {
    var f = this.files[0]; if (!f) return;
    var r = new FileReader();
    r.onload = function (ev) {
      if (f.size <= 1500000) {
        logoFile = { name: f.name, data: ev.target.result };
        libAdd(f.name, ev.target.result); // mémorisée pour tous les produits
      } else {
        logoFile = { name: f.name, data: null }; // trop lourd pour le stockage local : nom seulement
      }
      addImageToCanvas(ev.target.result);
    };
    r.readAsDataURL(f); this.value = '';
  });
  $('rdcfgBtnText').addEventListener('click', function () {
    var zb = zoneBounds();
    // défaut « pro » : Montserrat gras, taille généreuse (demande Denis 2026-08-14)
    var t = new fabric.IText('Votre texte', {
      left: (zb.l + zb.r) / 2, top: (zb.t + zb.b) / 2, originX: 'center', originY: 'center',
      fontFamily: 'Montserrat', fontWeight: '700', fontSize: Math.round(size * 0.09), fill: INK
    });
    t.rdArt = true;
    canvas.add(t); clampToZone(t); canvas.setActiveObject(t);
    // édition immédiate, placeholder entièrement sélectionné : taper remplace le texte d'exemple
    t.enterEditing();
    t.selectAll();
    canvas.requestRenderAll(); onArtChange();
  });
  // sortie d'édition : texte vide → on retire l'élément ; sinon on enregistre le contenu tapé
  canvas.on('text:editing:exited', function (e) {
    var o = e.target;
    if (o && !String(o.text || '').trim()) {
      canvas.remove(o); canvas.discardActiveObject(); canvas.requestRenderAll(); syncTools();
    }
    onArtChange();
  });
  $('rdcfgBtnClear').addEventListener('click', function () {
    canvas.getObjects().slice().forEach(function (o) { if (o.rdArt) canvas.remove(o); });
    canvas.discardActiveObject(); canvas.requestRenderAll(); syncTools(); onArtChange();
  });

  var TOUCH = window.matchMedia && matchMedia('(pointer: coarse)').matches;
  function updateHint() {
    var has = canvas.getObjects().some(function (o) { return o.rdArt; });
    var posName = POSITIONS[selPos] ? posLabel(POSITIONS[selPos].id) : '';
    $('rdcfgHint').textContent = has
      ? "Glissez pour déplacer · poignées d'angle pour redimensionner et pivoter · " + (TOUCH ? "touchez à nouveau un texte sélectionné pour l'éditer." : "double-clic sur un texte pour l'éditer.")
      : (posName ? '« ' + posName + ' » est vide — importez votre logo ou ajoutez du texte.' : 'Importez votre logo ou ajoutez du texte pour commencer.');
  }
  function onArtChange() {
    saveArt(); saveDraft(); renderPositions(); updateHint(); render(); renderWarnings();
    // la génération de miniature (toDataURL) consomme le cycle de rendu en attente :
    // on replanifie un rendu pour que l'ajout soit visible immédiatement
    canvas.requestRenderAll();
    setTimeout(function () { canvas.renderAll(); }, 50);
  }
  canvas.on('object:added', function () { updateHint(); });
  canvas.on('object:removed', function () { updateHint(); });
  canvas.on('object:modified', function () { saveArt(); saveDraft(); renderPositions(); renderWarnings(); });

  // ---- Récapitulatif prix ----
  function composedPositions() {
    saveArt();
    return POSITIONS.filter(function (p) { return artByPos[p.id] && artByPos[p.id].length; });
  }
  function render() {
    var lines = [], totalC = 0, unitC = 0, setupC = 0;
    var comp = composedPositions();
    if (isTextile) {
      comp.forEach(function (p) {
        var u = PR ? PR.atelierUnit(p, qty, MODE) : 0;
        lines.push('<div class="rdcfg__sline"><span>' + esc(posLabel(p.id)) + ' · ' + qty + ' × ' + fmt(u) + '</span><span class="v">' + fmt(u * qty) + '</span></div>');
        totalC += u * qty; unitC += u;
      });
      if (MODE === 'broderie' && PR && PR.BRODERIE_SETUP && comp.length) {
        var bs = PR.BRODERIE_SETUP * comp.length;
        lines.push('<div class="rdcfg__sline"><span>Mise en place broderie · ' + comp.length + ' emplacement' + (comp.length > 1 ? 's' : '') + ' <em>une seule fois</em></span><span class="v">' + fmt(bs) + '</span></div>');
        totalC += bs;
      }
      $('rdcfgSumNote').innerHTML = MODE === 'broderie'
        ? 'Prix de la <b>broderie seule</b>, dégressif selon la quantité, + mise en place (programmation de la machine) une fois par emplacement — bon à tirer offert. Le produit, les coloris et les tailles se règlent sur la fiche produit.'
        : 'Prix de la <b>personnalisation seule</b>, dégressif selon la quantité — notre atelier choisit la meilleure technique, bon à tirer offert. Le produit, les coloris et les tailles se règlent sur la fiche produit.';
    } else {
      comp.forEach(function (p) {
        var list = techsOf(p); var t = list[techByPos[p.id] || 0];
        if (!t || !PR) return;
        var mq = PR.markUnit(t.id, qty, PR.areaOf(p));
        if (!mq) { lines.push('<div class="rdcfg__sline"><span>' + esc(posLabel(p.id)) + ' · ' + esc(t.name) + '</span><span class="v">sur devis</span></div>'); return; }
        lines.push('<div class="rdcfg__sline"><span>' + esc(posLabel(p.id)) + ' · ' + esc(t.name) + ' · ' + qty + ' × ' + fmt(mq.perUnit) + '</span><span class="v">' + fmt(mq.perUnit * qty) + '</span></div>');
        lines.push('<div class="rdcfg__sline"><span>Frais de calage <em>une seule fois</em></span><span class="v">' + fmt(mq.setup) + '</span></div>');
        totalC += mq.perUnit * qty + mq.setup; unitC += mq.perUnit; setupC += mq.setup;
      });
    }
    if (!comp.length) {
      $('rdcfgSumLines').innerHTML = '<div class="rdcfg__sline"><span>Aucun visuel composé pour l\'instant</span><span class="v">—</span></div>';
      $('rdcfgSumTotal').textContent = '—';
      $('rdcfgSumUnit').textContent = '';
      return;
    }
    $('rdcfgSumLines').innerHTML = lines.join('');
    $('rdcfgSumTotal').innerHTML = totalC.toFixed(2).replace('.', ',') + '&nbsp;<small>€ HT</small>';
    $('rdcfgSumUnit').textContent = 'soit ' + fmt(totalC / qty) + ' HT / pièce · BAT offert';
  }

  // ---- Export BAT d'une position (JPEG compact, fond clair) ----
  function exportPos(cb) {
    var prevBg = canvas.backgroundColor;
    canvas.discardActiveObject();
    canvas.setBackgroundColor('#ffffff', function () {
      var data = null;
      try {
        data = canvas.toDataURL({ format: 'jpeg', quality: 0.85, multiplier: 1.5 });
      } catch (e) {
        // canevas « tainted » (image de fond sans CORS) : on exporte le visuel seul
        var bg = canvas.backgroundImage;
        canvas.setBackgroundImage(null, function () { });
        try { data = canvas.toDataURL({ format: 'jpeg', quality: 0.85, multiplier: 1.5 }); } catch (e2) { }
        if (bg) canvas.setBackgroundImage(bg, canvas.renderAll.bind(canvas));
      }
      canvas.setBackgroundColor(prevBg || '', canvas.renderAll.bind(canvas));
      cb(data);
    });
  }
  // Parcourt les positions composées : restaure chacune sur le canevas, exporte, puis revient.
  function exportAll(done) {
    var comp = composedPositions();
    var out = [], startPos = selPos;
    function step(i) {
      if (i >= comp.length) {
        selPos = startPos; refreshBg(); renderTechs(); restoreArt(function () { renderPositions(); });
        done(out); return;
      }
      var ix = POSITIONS.indexOf(comp[i]);
      saveArt(); selPos = ix; refreshBg();
      restoreArt(function () {
        // petit délai : laisse le fond (image CDN) se poser avant l'export
        setTimeout(function () {
          exportPos(function (data) {
            out.push({ id: comp[i].id, label: posLabel(comp[i].id), png: data });
            step(i + 1);
          });
        }, 350);
      });
    }
    step(0);
  }

  function toast(msg) {
    $('rdcfgToastMsg').textContent = msg;
    var t = $('rdcfgToast'); t.classList.add('show');
    clearTimeout(window._rdcfgTT); window._rdcfgTT = setTimeout(function () { t.classList.remove('show'); }, 3400);
  }

  // Planche récapitulative UNIQUE : chaque emplacement composé × chaque coloris sélectionné
  // (un texte noir sur tee-shirt noir se voit immédiatement) + avertissements en pied de page.
  function exportSheet(done) {
    var comp = composedPositions();
    var colors = SEL ? SEL.slice(0, 4) : [selColorObj || { name: '' }];
    var skipped = SEL && SEL.length > 4 ? SEL.length - 4 : 0;
    var startPos = selPos, startColor = selColorObj;
    var shots = [];
    var jobs = [];
    comp.forEach(function (p) { colors.forEach(function (c) { jobs.push({ p: p, c: c }); }); });
    (function step(i) {
      if (i >= jobs.length) {
        selPos = startPos; selColorObj = startColor;
        refreshBg(); renderTechs(); restoreArt(function () { renderPositions(); });
        done(shots, comp, colors, skipped);
        return;
      }
      var j = jobs[i];
      saveArt();
      selPos = POSITIONS.indexOf(j.p);
      selColorObj = j.c;
      refreshBg();
      restoreArt(function () {
        setTimeout(function () {
          exportPos(function (data) {
            shots.push({ pos: posLabel(j.p.id), color: j.c.name || '', png: data });
            step(i + 1);
          });
        }, 450);
      });
    })(0);
  }
  $('rdcfgBat').addEventListener('click', function () {
    if (!composedPositions().length) { toast('Ajoutez d\'abord votre logo ou du texte.'); return; }
    var btn = this; btn.disabled = true;
    toast('Génération de la planche — quelques secondes…');
    exportSheet(function (shots, comp, colors, skipped) {
      shots = shots.filter(function (s) { return s.png; });
      if (!shots.length) { btn.disabled = false; toast('Export impossible sur ce navigateur.'); return; }
      var warns = collectWarnings();
      var imgs = [], loaded = 0;
      shots.forEach(function (s, i) {
        var im = new Image();
        im.onload = function () { if (++loaded === shots.length) draw(); };
        im.src = s.png; imgs[i] = im;
      });
      function draw() {
        var pw = 420, ph = 420, head = 118, pad = 24, cap = 36;
        var cols = colors.length, rows = comp.length;
        var warnH = warns.length ? 34 + warns.length * 24 : 0;
        // instructions client en pied de planche (repliées sur ≤3 lignes)
        var noteLines = [];
        (function () {
          var n = (atelierNotes || '').trim(); if (!n) return;
          var line = '';
          n.split(/\s+/).forEach(function (w) {
            if ((line + ' ' + w).length > 110) { noteLines.push(line); line = w; }
            else line = line ? line + ' ' + w : w;
          });
          if (line) noteLines.push(line);
          noteLines = noteLines.slice(0, 3);
        })();
        var noteH = noteLines.length ? 34 + noteLines.length * 24 : 0;
        var W = Math.max(pad + cols * (pw + pad), 900);
        var H = head + rows * (ph + cap + pad) + warnH + noteH + pad;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d');
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
        g.fillStyle = '#1d1d1f'; g.font = '600 28px -apple-system, Inter, sans-serif';
        g.fillText('REVDECO — Bon à tirer provisoire', pad, 42);
        g.font = '400 17px -apple-system, Inter, sans-serif'; g.fillStyle = '#6e6e73';
        g.fillText((ctx.title || '') + (ctx.code ? ' · Réf. ' + ctx.code : '') + ' · ' + qty + ' pièce' + (qty > 1 ? 's' : '')
          + (isTextile ? ' · ' + (MODE === 'broderie' ? 'Broderie' : 'Impression') : ''), pad, 70);
        var selLine = SEL ? SEL.map(function (c) { return c.qty + ' ' + c.name; }).join(' + ') : (selColorObj && selColorObj.name ? selColorObj.name : '');
        if (selLine) g.fillText(selLine + (skipped ? ' (+' + skipped + ' coloris non affichés)' : '') + ' — le même visuel s\'applique à tous les coloris', pad, 94);
        shots.forEach(function (s, i) {
          var r = Math.floor(i / cols), c = i % cols;
          var cx = pad + c * (pw + pad);
          var cy = head + r * (ph + cap + pad);
          g.fillStyle = '#1d1d1f'; g.font = '600 16px -apple-system, Inter, sans-serif';
          g.fillText(s.pos + (s.color ? ' — ' + s.color : ''), cx, cy + 20);
          var im = imgs[i];
          var sc2 = Math.min(pw / im.width, ph / im.height);
          g.drawImage(im, cx, cy + cap, im.width * sc2, im.height * sc2);
          g.strokeStyle = '#d2d2d7'; g.strokeRect(cx - 0.5, cy + cap - 0.5, pw + 1, ph + 1);
        });
        if (warns.length) {
          var wy = head + rows * (ph + cap + pad) + 8;
          g.fillStyle = '#854f0b'; g.font = '600 16px -apple-system, Inter, sans-serif';
          g.fillText('Points d\'attention avant impression :', pad, wy);
          g.font = '400 14px -apple-system, Inter, sans-serif';
          warns.forEach(function (w, i2) { g.fillText('⚠ ' + w.slice(0, 130), pad, wy + 26 + i2 * 24); });
        }
        if (noteLines.length) {
          var ny = head + rows * (ph + cap + pad) + warnH + 8;
          g.fillStyle = '#1d1d1f'; g.font = '600 16px -apple-system, Inter, sans-serif';
          g.fillText('Instructions du client (à confirmer sur ce BAT) :', pad, ny);
          g.font = '400 14px -apple-system, Inter, sans-serif';
          noteLines.forEach(function (l, i3) { g.fillText('✎ ' + l, pad, ny + 26 + i3 * 24); });
        }
        var a = document.createElement('a');
        a.href = cv.toDataURL('image/jpeg', 0.86);
        a.download = 'REVDECO-BAT-' + (ctx.code || ctx.handle) + '.jpg';
        document.body.appendChild(a); a.click(); a.remove();
        btn.disabled = false;
        toast('Planche téléchargée : chaque emplacement dans chacun de vos coloris.');
      }
    });
  });

  $('rdcfgValidate').addEventListener('click', function () {
    var comp = composedPositions();
    if (!comp.length) { toast('Composez d\'abord un visuel (logo ou texte) sur au moins un emplacement.'); return; }
    var btn = this; btn.disabled = true; btn.textContent = 'Enregistrement…';
    exportAll(function (out) {
      var cfg = {
        ts: Date.now(), qty: qty,
        positions: out.map(function (o, i) {
          var pos = comp[i];
          var entry = { id: o.id, label: o.label, png: o.png };
          if (!isTextile) {
            var t = techsOf(pos)[techByPos[pos.id] || 0];
            if (t) entry.tech = { id: t.id, name: t.name };
          }
          return entry;
        }),
        logo: logoFile,
        mode: isTextile ? MODE : undefined, // technique fiche (impression/broderie) — restaurée au retour
        // points d'attention (contraste, définition, petit texte…) : rappelés sur la fiche
        warns: collectWarnings(),
        // souhaits libres du client — joints à la commande, confirmés sur BAT
        notes: (atelierNotes || '').trim().slice(0, 300) || undefined,
        // source modifiable : permet de rouvrir l'éditeur et re-valider sans rien refaire
        art: { artByPos: artByPos, thumbs: thumbByPos, techByPos: techByPos }
      };
      try {
        localStorage.setItem('revdeco-cfg-' + ctx.handle, JSON.stringify(cfg));
      } catch (e) {
        // stockage plein (visuels lourds) : on sacrifie d'abord la source modifiable…
        delete cfg.art;
        try {
          localStorage.setItem('revdeco-cfg-' + ctx.handle, JSON.stringify(cfg));
        } catch (e1) {
          // …puis les aperçus, on garde au minimum les emplacements
          cfg.positions.forEach(function (p) { delete p.png; });
          cfg.logo = logoFile ? { name: logoFile.name, data: null } : null;
          try { localStorage.setItem('revdeco-cfg-' + ctx.handle, JSON.stringify(cfg)); } catch (e2) { }
        }
      }
      try { sessionStorage.removeItem(DRAFT_KEY); } catch (e3) { }
      window.location.href = back + (back.indexOf('?') === -1 ? '?' : '&') + 'personnalise=1';
    });
  });

  // ---- Brouillon de composition : survit à l'aller-retour vers la fiche ----
  var DRAFT_KEY = 'revdeco-draft-' + ctx.handle;
  var atelierNotes = ''; // instructions libres pour l'atelier (confirmées sur BAT)
  function saveDraft() {
    try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ artByPos: artByPos, thumbs: thumbByPos, logo: logoFile, techByPos: techByPos, notes: atelierNotes })); } catch (e) { }
    // indicateur discret « ✓ Enregistré » : le client sait que rien ne se perd
    var s = $('rdcfgSaved');
    if (s) {
      s.style.opacity = '1';
      clearTimeout(window._rdcfgSavedT);
      window._rdcfgSavedT = setTimeout(function () { s.style.opacity = '0'; }, 1800);
    }
  }
  try {
    var draft = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null');
    if (draft && draft.artByPos) {
      artByPos = draft.artByPos;
      thumbByPos = draft.thumbs || {};
      logoFile = draft.logo || null;
      techByPos = draft.techByPos || {};
      atelierNotes = draft.notes || '';
    } else {
      // pas de brouillon (ex. « Modifier mon visuel » après validation) : on repart
      // de la composition validée, à nouveau modifiable — rien à refaire pour re-valider
      var savedCfg = JSON.parse(localStorage.getItem('revdeco-cfg-' + ctx.handle) || 'null');
      if (savedCfg && savedCfg.art && savedCfg.art.artByPos) {
        artByPos = savedCfg.art.artByPos;
        thumbByPos = savedCfg.art.thumbs || {};
        techByPos = savedCfg.art.techByPos || {};
        if (savedCfg.logo && savedCfg.logo.data) logoFile = savedCfg.logo;
        atelierNotes = savedCfg.notes || '';
      }
    }
  } catch (e) { }

  // champ « Instructions pour l'atelier » : restauré, sauvegardé en tapant (débounce)
  (function () {
    var na = $('rdcfgNotes'); if (!na) return;
    na.value = atelierNotes;
    var t = null;
    na.addEventListener('input', function () {
      atelierNotes = this.value;
      clearTimeout(t); t = setTimeout(saveDraft, 800);
    });
  })();

  // accès debug (tests automatisés / diagnostic console)
  window.__rdcfg = { canvas: canvas, artByPos: artByPos, zoneBounds: zoneBounds, composed: composedPositions };

  // ---- Démarrage ----
  renderLibrary();
  renderColors();
  renderPositions();
  renderTechs();
  refreshBg();
  // brouillon éventuel : restaure le visuel de l'emplacement actif
  restoreArt(function () { renderPositions(); updateHint(); render(); renderWarnings(); });
  updateHint();
  render();
  if (!POSITIONS.length) $('rdcfgToolsNo').textContent = 'I';
});
